/** Quotes + proposals API — /api/v1/kosh/quotes, /kosh/proposals. */
import { apiClient } from './api-client';
import type { Paginated } from '@/types/kosh';
import type {
  KoshProposal,
  KoshProposalStatus,
  KoshQuote,
  KoshQuoteStatus,
} from '@/types/commercial-docs';

type Query = Record<string, string | number | boolean | undefined>;
function rows<T>(d: Paginated<T> | T[] | null | undefined): T[] {
  if (!d) return [];
  return Array.isArray(d) ? d : d.items;
}

export const quotesApi = {
  list: async (params?: Query) => {
    const { data } = await apiClient.get<Paginated<KoshQuote> | KoshQuote[]>('/kosh/quotes', {
      params,
    });
    return rows<KoshQuote>(data);
  },
  get: (id: string) => apiClient.get<KoshQuote>(`/kosh/quotes/${id}`).then((r) => r.data),
  transition: (id: string, to: KoshQuoteStatus) =>
    apiClient.post<KoshQuote>(`/kosh/quotes/${id}/transitions`, { to }).then((r) => r.data),
};

export const proposalsApi = {
  list: async (params?: Query) => {
    const { data } = await apiClient.get<Paginated<KoshProposal> | KoshProposal[]>(
      '/kosh/proposals',
      { params },
    );
    return rows<KoshProposal>(data);
  },
  get: (id: string) =>
    apiClient.get<KoshProposal>(`/kosh/proposals/${id}`).then((r) => r.data),
  transition: (id: string, to: KoshProposalStatus) =>
    apiClient
      .post<KoshProposal>(`/kosh/proposals/${id}/transitions`, { to })
      .then((r) => r.data),
};
